<template>
  <div class="box">
    <img :src="$OSSBaseUrl+'Vector.png'" class="icon" alt="">
    <div class="tips_title">重要提醒</div>
    <div class="tips_text">您的店铺响应率<span>低于同行16.4%,</span>客户流失较多已经严重影响您的<span>店铺销售额！</span></div>
    <div class="tips_bottom">使用后响应率平均<span>提升83%</span></div>
    <div class="tips_bottom"><span>销售额翻倍</span></div>
    <div @click="show_popup" class="tips_button">立即提升</div>
    <Popup v-model="popup_show"
      position="top"
      overlay-class="popup_box"
      :close-on-click-overlay="false"
      :lock-scroll="true"
      :lazy-render="false">
      <img class="WXTExtension_popup" :src="popup_img">
    </Popup>
  </div>
</template>
<script>
import {Popup} from 'vant';
export default {
  name: 'Info20210318',
  components:{Popup},
  data(){
    let popup_img
    if(this.$config.SystemOS=='IOS'){
        popup_img = this.$OSSBaseUrl +'renew_tips_ios.png';
    }else{
        popup_img = this.$OSSBaseUrl + 'renew_tips_android.png';
    }
    return{
      popup_img,
      popup_show: false,
    }
  },
  mounted(){
    this.maidian()
  },
  methods:{
    show_popup(){
      this.maidian({btn_name:'WarningTips'})
      this.popup_show=true
    },
    maidian(params={}){
      params['dayhour'] = this.$route.query.dayhour
      let data = {
          page_from:'main_page',
          page_name:'WarningTips',
          page_time:'0.00',
          receiver_id: '',
          page_param: params,
      }
      this.$store.dispatch('Public/inH5Record', data)
    }
  },
}
</script>
<style lang="scss" scoped>
  @import './index.scss';
</style>